module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rate-breakdown-window"
    }
  }, [_c('section', {
    staticClass: "box-shadow col-xs-12 col-sm-10 col-lg-8 col-sm-offset-1 col-lg-offset-2",
    attrs: {
      "id": "rate-breakdown-box"
    }
  }, [_c('header', [_c('i', {
    staticClass: "ion ion-close-round sm",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('blockquote', [_vm._v("\n        Accepted Route - Totals\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-justified mai-nav-pills"
  }, [_c('li', {
    class: [_vm.pill === 'overview' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'overview'
      }
    }
  }, [_c('a', [_vm._v("Overview")])]), _vm._v(" "), (_vm.accessorialsEnabled) ? _c('li', {
    class: [_vm.pill === 'accessorials' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'accessorials'
      }
    }
  }, [_c('a', [_vm._v("Accessorials")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: [_vm.pill === 'costs' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'costs'
      }
    }
  }, [_c('a', [_vm._v("Costs")])]), _vm._v(" "), _c('li', {
    class: [_vm.pill === 'charges' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'charges'
      }
    }
  }, [_c('a', [_vm._v("Charges")])]), _vm._v(" "), _c('li', {
    class: [_vm.pill === 'compare' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'compare'
      }
    }
  }, [_c('a', [_vm._v("Comparison")])])]), _vm._v(" "), _c('main', {
    staticClass: "clearfix box-shadow",
    attrs: {
      "id": "totals-table-container"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pill === 'overview'),
      expression: "pill === 'overview'"
    }]
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("First Name *")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "is-input",
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }, function($event) {
        return _vm.$emit('dataChange', {
          firstName: _vm.firstName
        })
      }]
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last Name *")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "is-input",
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }, function($event) {
        return _vm.$emit('dataChange', {
          lastName: _vm.lastName
        })
      }]
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pickup Date *")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickUpDate),
      expression: "pickUpDate"
    }],
    staticClass: "is-input",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.pickUpDate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pickUpDate = $event.target.value
      }, _vm.validatePickUpDate]
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("External Reference *")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invalidReferenceNumber),
      expression: "invalidReferenceNumber"
    }],
    staticClass: "validation-error"
  }, [_vm._v("Invalid Reference Number")]), _vm._v(" "), (_vm.isCrownRefFormatEnabled) ? _c('div', {
    staticClass: "flex-container pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text1),
      expression: "referenceNumber.text1"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text1)
    },
    on: {
      "blur": _vm.validateReferenceText1,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text2),
      expression: "referenceNumber.text2"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text2)
    },
    on: {
      "blur": _vm.validateReferenceText2,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceNumber.text3),
      expression: "referenceNumber.text3"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.referenceNumber.text3)
    },
    on: {
      "blur": _vm.validateReferenceText3,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.referenceNumber, "text3", $event.target.value)
      }
    }
  })]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reference),
      expression: "reference"
    }],
    staticClass: "is-input",
    domProps: {
      "value": (_vm.reference)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.reference = $event.target.value
      }, function($event) {
        return _vm.$emit('dataChange', {
          reference: _vm.reference
        })
      }]
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.response.responseCurrency) + " Estimate")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.rateServices), function(rate) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(rate.serviceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(rate.cost)))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "border-bottom-td border-top-td"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(_vm.totalCost)))])]), _vm._v(" "), _vm._l((_vm.copyOfFinanceItems), function(f) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(f.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(f.amount)))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('td', [_vm._v("Rate Adjustment")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rateAdjustmentAmount !== 'N/A' ? _vm.numberFormat(_vm.rateAdjustmentAmount) : 'N/A'))])]), _vm._v(" "), _c('tr', {
    staticClass: "border-top-td"
  }, [_c('td', [_vm._v("Total Charge")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalCharge),
      expression: "totalCharge"
    }],
    staticClass: "is-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.totalCharge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.totalCharge = $event.target.value
      }, _vm.updateChargesFromTotal]
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "input-tr border-bottom-td"
  }, [_c('td', {
    staticClass: "no-pad"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayType),
      expression: "displayType"
    }],
    staticClass: "is-input",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.displayType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "lbs"
    }
  }, [_vm._v("Per 100 Lbs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kg"
    }
  }, [_vm._v("Per Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cuft"
    }
  }, [_vm._v("Per Cb.Ft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cum"
    }
  }, [_vm._v("Per Cb.M")])])]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [(_vm.displayType === 'lbs') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lbs),
      expression: "lbs"
    }],
    staticClass: "is-input",
    attrs: {
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.lbs)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.lbs = $event.target.value
      }, _vm.updateAfterLbsChange]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayType === 'kg') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kg),
      expression: "kg"
    }],
    staticClass: "is-input",
    attrs: {
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.kg)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.kg = $event.target.value
      }, _vm.updateAfterKgChange]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayType === 'cum') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cum),
      expression: "cum"
    }],
    staticClass: "is-input",
    attrs: {
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.cum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cum = $event.target.value
      }, _vm.updateAfterCumChange]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.displayType === 'cuft') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cuft),
      expression: "cuft"
    }],
    staticClass: "is-input",
    attrs: {
      "step": "0.01",
      "type": "number"
    },
    domProps: {
      "value": (_vm.cuft)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cuft = $event.target.value
      }, _vm.updateAfterCuftChange]
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.accessorialsEnabled) ? _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "sub-header"
  })]) : _vm._e(), _vm._v(" "), (_vm.accessorialsEnabled) ? _c('tr', [_c('td', [_vm._v("Origin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(_vm.originAccessorialsTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.accessorialsEnabled) ? _c('tr', {
    staticClass: "border-bottom-td"
  }, [_c('td', [_vm._v("Destination")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(_vm.destinationAccessorialsTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.quoteTaxesEnabled) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "sub-header"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.taxes), function(tax) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(tax.serviceName) + " "), (tax.note) ? _c('span', [_vm._v("(" + _vm._s(tax.note) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(tax.baseRate)) + "%")])])
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', {
    staticClass: "border-top-td"
  }, [_c('td', [_vm._v("Profit")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numberFormat(_vm.profit)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Markup")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.markup) + "%")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Gross Margin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.grossMargin) + "%")])])], 2)])])]), _vm._v(" "), (_vm.pill === 'accessorials') ? _c('div', [_c('quote-accessorials', {
    attrs: {
      "job": _vm.job && _vm.job.job,
      "reporting-currency": _vm.reportingCurrency,
      "rate": _vm.rate,
      "rate-request": _vm.request,
      "job-accessorials": _vm.jobAccessorials
    },
    on: {
      "update-job-accessorials": _vm.updateJobAccessorials
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.pill === 'costs') ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-bar', {
    attrs: {
      "chartData": _vm.costsBarData,
      "valueField": "Rate",
      "categoryField": "Service"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-pie', {
    attrs: {
      "chartData": _vm.costsBarData,
      "valueField": "Rate",
      "categoryField": "Service"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.pill === 'charges') ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-bar', {
    attrs: {
      "chartData": _vm.chargesBarData,
      "valueField": "Amount",
      "categoryField": "Name"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-pie', {
    attrs: {
      "chartData": _vm.chargesBarData,
      "valueField": "Amount",
      "categoryField": "Name"
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.pill === 'compare') ? _c('div', [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-stacked-bar', {
    attrs: {
      "chartData": _vm.stackedData,
      "categoryField": "Category"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-pie', {
    attrs: {
      "chartData": _vm.costsCompare,
      "valueField": "Rate",
      "categoryField": "Service"
    }
  })], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "pull-right full-w-sm"
  }, [_c('div', {
    staticClass: "btn btn-success sq half-w-sm",
    on: {
      "click": _vm.saveJob
    }
  }, [_vm._v("\n          Save "), _c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary sq half-w-sm",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          Back "), _c('i', {
    staticClass: "fa fa-backward"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("Input")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sub-header"
  }, [_c('b', [_vm._v("Accessorials")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sub-header"
  }, [_c('b', [_vm._v("GST-VAT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Costs by Service - Bar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Costs by Service - Pie")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Charges by Service - Bar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Charges by Service - Pie")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Costs by Service - Bar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Costs by Service - Pie")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89ccb3d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteRateBreakDown.vue
// module id = 2251
// module chunks = 1